import * as React from 'react';
import { useSelector } from 'react-redux';

import { ProblemChoicePopup } from '../../components/ChoicePopup';
import { selectIsProblem, selectNewbuildingUrl } from '../../selectors/newbuilding';

export const ProblemChoicePopupContainer: React.VFC = () => {
  const isProblem = useSelector(selectIsProblem);
  const url = useSelector(selectNewbuildingUrl);

  if (!isProblem) {
    return null;
  }

  return <ProblemChoicePopup url={url + '#problem'} />;
};
